function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M12276 0c3385 0 6454 1346 8676 3521 2224 2177 3600 5185 3600 8507 0 3323-1376 6330-3600 8507-2222 2176-5291 3522-8676 3522s-6454-1346-8676-3522C1376 18358 0 15351 0 12028c0-3322 1376-6330 3600-8507C5822 1346 8891 0 12276 0zm7869 4341c-2011-1968-4794-3187-7869-3187S6418 2373 4407 4341c-2009 1967-3253 4685-3253 7687s1244 5721 3253 7687c2011 1969 4794 3187 7869 3187s5858-1218 7869-3187c2009-1966 3253-4685 3253-7687s-1244-5720-3253-7687z",
  className: "fil0"
}), React.createElement("path", {
  d: "M5790 12820l3305 4 35 1544 1483 2 9-5240c-156-582-508-646-959-1068-979-916-1607-1606-2664-1604l-2650 15-5 7926 1460 8-14-1587zm14418 27l-6-1530-3207-73-6-1530-1518-5-9 1525-3180 16 2 1562 4530-1c-122 409-623 1144-946 1384-454-276-648-616-1029-941-266 210-913 716-1127 990 251 394 605 649 918 1021-130 124 96-36-200 172l-777 363c-424 135-881 203-1371 223l2 1575c1894-73 2377-526 3669-1224 1160 616 1533 1150 3291 1224v-1572c-806-62-1559-448-2117-800 226-369 552-693 830-1130 275-432 456-916 721-1290l1530 41zM5880 11239l3191 6c192-1906-88-1642-1283-2676-616-534-313-596-1895-529l-13 3199z",
  className: "fil1"
})));

var SvgIcon = function SvgIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21.272,
    height: 20.843,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 24552 24057",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon.5e281c2d.svg";
export { ForwardRef as ReactComponent };